var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrowD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 79,
    viewBox: "0 0 31 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0858 78.4142C14.8668 79.1953 16.1332 79.1953 16.9142 78.4142L29.6421 65.6863C30.4232 64.9052 30.4232 63.6389 29.6421 62.8579C28.8611 62.0768 27.5948 62.0768 26.8137 62.8579L15.5 74.1716L4.18629 62.8579C3.40524 62.0768 2.13891 62.0768 1.35786 62.8579C0.576815 63.6389 0.576815 64.9052 1.35786 65.6863L14.0858 78.4142ZM17.5 77L17.5 -8.74228e-08L13.5 8.74228e-08L13.5 77L17.5 77Z",
    fill: "#214424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowD);
export default __webpack_public_path__ + "static/media/long-arrow-d.438f18832c9191800a9612f2f936c5b3.svg";
export { ForwardRef as ReactComponent };